// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"fe-z","landingPageVideo":"ge-z","play":"he-z","iframeVideo":"ie-z","playHidden":"je-z","fullwidth":"ke-z"};